import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ThemePalette } from '@angular/material/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Push } from 'app/shared/models/class/notification/notification';
import { NotificationService } from 'app/shared/services/notification/notification.service';

@Component({
  selector: 'app-open-dialog-add-notification',
  templateUrl: './open-dialog-add-notification.component.html',
  styleUrls: ['./open-dialog-add-notification.component.scss']
})
export class OpenDialogAddNotificationComponent implements OnInit {

  addNotificationForm!: UntypedFormGroup;

  color: ThemePalette = 'primary';
  isProg: boolean = true;
  today: Date = new Date();
  time!: string;

  constructor(
    public dialogRef: MatDialogRef<OpenDialogAddNotificationComponent>,
    private formBuilder: UntypedFormBuilder,
    private notificationService: NotificationService
  ) { }

  ngOnInit(): void {
    this.initForm();
  }

  onSubmit(): void {

    const push = new Push(this.f.title.value, this.f.body.value);

    switch (this.isProg) {
      case true:
        const date = new Date(this.f.sendDate.value);
        const time = this.f.time.value.split(':');

        date.setHours(time[0]);
        date.setMinutes(time[1]);
        date.setSeconds(0);
        push.sendDate = date;

        this.notificationService.addNotificationProg(push).subscribe({
          next: () => this.dialogRef.close()
        })

        break;

      case false:
        this.notificationService.addNotificationNow(push).subscribe({
          next: () => this.dialogRef.close()
        })
        break;

      default:
        break;
    }
  }

  get f() {
    return this.addNotificationForm.controls;
  }

  private initForm(): void {
    const today = new Date();
    const time = `${today.getHours()}:${today.getMinutes()}`
    this.addNotificationForm = this.formBuilder.group({
      title: ['', Validators.required],
      body: ['', Validators.required],
      sendDate: [today, Validators.required],
      time: [time, Validators.required]
    })

  }

}
